export const replaceNullValueInObj = data => {
	for (let entity in data) {
		if (typeof data[entity] !== 'number' && typeof data[entity] !== 'boolean' && !data[entity]) data[entity] = ''
	}
	return data
}
